const b64urlEncode = (data: string) => {
  return encodeURIComponent(btoa(data));
};

const b64urlDecode = (data: string) => {
  return atob(decodeURIComponent(data));
};

export { b64urlDecode, b64urlEncode };
